import { FunctionComponent } from "react";
import "./styles.scss";

type Props = {
  title: string;
  description: string;
};

const TextSection: FunctionComponent<Props> = ({ title, description }) => {
  return (
    <div className="text-section">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
};

export default TextSection;
